import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';

export interface AditoolsSectionSubheaderSignature {
  Element: HTMLDivElement;
  Args: {
    modalTitle?: string; // Conditionally required
    modalMessage?: string; // Conditionally required
    title?: string; // Optional
    close?: () => void; // Optional
    tooltip?: string; // Optional
    enableModalIcon?: boolean; // Optional
    qaName?: string; // Optional
    icon?: string; // Optional
    closeButtonText?: string; // Optional
    dialogClass?: string; // Optional
  };
  Blocks: {
    default: [];
  };
}
type AditoolsSectionSubheaderArgs = AditoolsSectionSubheaderSignature['Args'];

export default class AditoolsSectionSubheader extends Component<AditoolsSectionSubheaderSignature> {
  @service intl: any;
  @tracked modalEnabled = false;

  constructor(owner: unknown, args: AditoolsSectionSubheaderArgs) {
    super(owner, args);
    if (this._enableModalIcon) {
      assert('`modalTitle` is required', !isNone(this.args.modalTitle));
      assert('`modalMessage` is required', !isNone(this.args.modalMessage));
    }
  }

  get _modalTitle() {
    return this.args.modalTitle ?? '';
  }
  get _modalMessage() {
    return this.args.modalMessage ?? '';
  }

  get _closeButtonText() {
    return this.args.closeButtonText ?? this.intl.t('ember-aditools-page.common.cancel');
  }

  get _tooltip() {
    return this.args.tooltip ?? this.intl.t('ember-aditools-page.card.help-tooltip');
  }

  get _enableModalIcon() {
    return this.args.enableModalIcon ?? false;
  }

  get qaTooltipName() {
    return this.args.qaName ?? 'unnamed';
  }

  get buttonClass() {
    if (this.args.icon === 'help') {
      return 'action--help';
    } else {
      return 'action--info';
    }
  }
  @action closeModal(close?: () => void) {
    if (close) {
      close();
    }
    this.modalEnabled = false;
  }
  @action enableModal(evt: Event) {
    if (evt instanceof KeyboardEvent) {
      if (evt.type === 'click' || ['Enter', ' '].includes(evt.key)) {
        this.modalEnabled = true;
      } else {
        return;
      }
    }
    this.modalEnabled = true;
  }
}
